import { createStyles } from "@mantine/core";
import { INPUT_HEIGHT } from "./constants";
import { IDNSAliasInputProps } from "./types";

export const useStyles = createStyles(
  (theme, { disabled }: Pick<IDNSAliasInputProps, "disabled">) => ({
    wrapper: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      width: "100%",
    },

    input: {
      flex: "1 0 auto",

      "input[type=text]": {
        borderBottomRightRadius: 0,
        borderTopRightRadius: 0,
        display: "inline-block",
        fontSize: theme.fontSizes.sm,
        fontStretch: "100%",
        fontStyle: "normal",
        height: `${INPUT_HEIGHT}px`,
        lineHeight: 1,
        margin: 0,
        padding: `${theme.spacing.sm - 1}px ${theme.spacing.sm}px ${
          theme.spacing.sm + 1
        }px ${theme.spacing.md}px`,
        position: "relative",
        textAlign: "left",
        verticalAlign: "bottom",
        width: "100%",
        zIndex: 1,
      },
    },

    label: {
      alignItems: "center",
      backgroundColor: theme.colors.gray[1],
      border: `1px solid ${theme.colors.gray[2]}`,
      borderBottomRightRadius: theme.radius.md,
      borderTopRightRadius: theme.radius.md,
      borderLeft: "none",
      color: theme.colors.gray[5],
      display: "flex",
      fontSize: theme.fontSizes.sm,
      fontStretch: "100%",
      fontStyle: "normal",
      height: `${INPUT_HEIGHT}px`,
      justifyContent: "center",
      lineHeight: 1,
      margin: 0,
      opacity: disabled ? theme.other.disabled.opacity : 1,
      padding: `${theme.spacing.sm - 1}px ${theme.spacing.md}px ${
        theme.spacing.sm + 1
      }px ${theme.spacing.sm}px`,
      pointerEvents: "none",
      position: "relative",
      textAlign: "left",
      userSelect: "none",
      verticalAlign: "bottom",
      width: "auto",
    },
  }),
);
